<script>
export default {
    name: 'SalesReceipt',

     data () {
        return {
            invoiceDetails: {},
            invoiceLines: []
        };
    },

    computed: {
        subTotalLines () {

        if(!this.invoiceLines.length) return 0;

        return this.invoiceLines.map(line => line.total ? parseFloat(line.total) : 0).reduce((sum, total) => sum + total);
      },

      grandTotalLines () {

        if(!this.invoiceLines.length) return 0;

        return this.invoiceLines.map(line => parseFloat(line.grandTotal)).reduce((sum, gTotal) => sum + gTotal);
      },

      taxLines () {

        if(!this.invoiceLines.length) return 0;

        return this.invoiceLines
            .map( line => (parseFloat(line.tax)/100) * parseFloat(line.total) )
                .reduce( (sum, tax) => sum + tax );
      },

      discountLines () {

        if(!this.invoiceLines.length) return 0;

        return this.invoiceLines
            .map( line => (parseFloat(line.discount)/100) * parseFloat(line.total) )
                .reduce( (sum, discount) => sum + discount );
      }
    },

    mounted() {

        this.fetchInvoiceDetails().then(() => {
            this.fetchInvoiceLines().then(() => {
                window.print();
            //  window.onafterprint = function() { window.close() }; 
            });
        });
    },

    methods: {

        fetchInvoiceDetails() {
            return this.$accountsHttp.get(`SupplierInvoice/PostedSpecificInvoice?InvoiceNo=${this.$router.currentRoute.params.invoiceNo}`).then(response => {
                this.invoiceDetails = response.data[0];
                
            });
        }, 

        fetchInvoiceLines() {
            return this.$accountsHttp.get(`SupplierInvoice/postedInvoiceDetails?InvoiceNo=${this.invoiceDetails.invoiceNo}&UserName=${this.invoiceDetails.userName}`)
                .then(response => {
                    this.invoiceLines = response.data;
                });
        }
    }
}
</script>

<template>
    <div class="w-full">
        <tail-address-header></tail-address-header>
         <div class="flex justify-center p-2">
            <h3 class="text-center font-bold text-sm">SUPPLIER INVOICE</h3>
        </div>
        <div class="flex justify-center p-2">
            <h4 class="font-bold text-sm">{{ invoiceDetails.supplier }}</h4>
        </div>
        <div class="flex flex-row w-full p-1">
            <div class="flex-1 px-1">
                <h4 class="font-bold text-sm">Date: {{ invoiceDetails.txnDate | dateFormat }}</h4>
            </div>
            <div class="flex-1 px-1">
               <h4 class="font-bold text-sm">Invoice No: {{ invoiceDetails.invoiceNo }}</h4> 
            </div>
            <div class="flex-1 px-1">
                <h4 class="font-bold text-sm">Ext Ref: {{ invoiceDetails.extRef }}</h4>
            </div>
            <div class="flex-1 px-1">
                <h4 class="font-bold text-sm">GRN Ref: {{ invoiceDetails.grnRef }}</h4>
            </div>
            <div class="flex-1 px-1">
                <h4 class="font-bold text-sm">LPO Ref: {{ invoiceDetails.lpoRefNo }} </h4>
            </div>
        </div>
        <div class="w-full">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th class="text-sm p-tiny">Item</th>
                        <th class="text-sm p-tiny">Description</th>
                        <th class="text-sm p-tiny">LPO Qty</th>
                        <th class="text-sm p-tiny">GRN Qty</th>
                        <th class="text-sm p-tiny">Qty</th>
                        <th class="text-sm p-tiny">Bonus</th>
                        <th class="text-sm p-tiny">Price</th>
                        <th class="text-sm p-tiny">Discount</th>
                        <th class="text-sm p-tiny">Tax</th>
                        <th class="text-sm p-tiny">Grand Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(invLine, index) in invoiceLines" :key="index">
                        <td class="text-xs p-tiny">{{ invLine.itemName }}</td>
                        <td class="text-xs p-tiny">{{ invLine.description }}</td>
                        <td class="text-xs p-tiny">{{ invLine.orderedQty }}</td>
                        <td class="text-xs p-tiny">{{ invLine.grnQty }}</td>
                        <td class="text-xs p-tiny">{{ invLine.qty }}</td>
                        <td class="text-xs p-tiny">{{ invLine.bonus }}</td>
                        <td class="text-xs p-tiny">{{ invLine.unitPrice }}</td>
                        <td class="text-xs p-tiny">{{ invLine.discount }}</td>
                        <td class="text-xs p-tiny">{{ invLine.tax }}</td>
                        <td class="text-xs p-tiny">{{ invLine.grandTotal }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="flex flex-wrap w-full my-2 p-1 border-2 bg-gray-200">
          <div class="flex-1 flex justify-center"><b>Sub Total: </b><span class="font-bold ml-1"> {{ subTotalLines | numberFormat }}</span></div>
          <div class="flex-1 flex justify-center"><b>Tax: </b> <span class="font-bold ml-1"> {{ taxLines | numberFormat }}</span></div>
          <div class="flex-1 flex justify-center"><b>Discount: </b><span class="font-bold ml-1"> {{ discountLines | numberFormat }}</span></div>
          <div class="flex-1 flex justify-center"><b>Grand Total: </b><span class="font-bold ml-1"> {{ grandTotalLines | numberFormat }}</span></div>
        </div>
        <div class=" w-full"  v-if="$root.checkAuth('ViewLPOSignatories')">
            <div class="flex-1">
                <h4 class="font-bold text-sm">Prepared By: ____________________________________________________________ Signature:________________________ Date:________________________</h4>
            </div>
            <div class="flex-1 mt-2">
                <h4 class="font-bold text-sm">Approved By: ____________________________________________________________ Signature:________________________ Date:________________________</h4>
        
            </div><div class="flex-1 mt-2">
                <h4 class="font-bold text-sm">Received By:_____________________________________________________________ Signature:________________________ Date:________________________</h4>
        
            </div>
            
        </div></div>
</template>
